export default "__VITE_ASSET__BLghET9Z__"